module.exports = __webpack_public_path__ + "static/media/nru.b4221fbb.svg";